module.exports = __webpack_public_path__ + "img/spezialisierungen_3000.6c57d1bf.webp";